import axios from 'axios'


export const authentication = {
    namespaced: true,
    state: () => ({
        authenticated: false,
        user: null,
        token: null
      }),
    getters: {
        isAuthenticated: state => state.authenticated,
        currentUser: state => state.user,
        token: state => state.token
    },
    mutations: {
        addWebToken: (state, data) => {
            if(data) {
                state.user = {
                    user_id: data.id,
                    email: data.email,
                    name: data.name,
                    role: data.role,
                }
                state.token = data.token
                state.authenticated = true
            } else {
                state.user = null                
                state.token = null
                state.authenticated = false
            }
        }
    },
    actions: {
        login: (context, data) => {
            const apiUrl = process.env.VUE_APP_BASE_URL;
            return axios.post(apiUrl + '/login',{
                email: data.email,
                password: data.password
            })
            .then( res => {
                if(res.data.token) {
                    // Guardar token y user en localStorage
                    localStorage.setItem('token', res.data.token);
                    localStorage.setItem('user', JSON.stringify({
                        id: res.data.id,
                        name: res.data.name,
                        email: res.data.email,
                        role: res.data.role,
                    }));
                    context.commit('addWebToken', res.data)
                }
                return res.data
            })
            .catch( err => {
                if (err.response && err.response.status === 401) {
                    return { status: 'error', message: 'Credenciales inválidas. Verificá tu email y contraseña.' }
                } else {
                    return { status: 'error', message: 'Error inesperado al iniciar sesión.' }
                } 
            })
        },
        logout: (context) => {
            context.commit('addWebToken', null)
            localStorage.removeItem('token');
            localStorage.removeItem('user');            
            return 'ok'
        }
    }

}
